import { render, staticRenderFns } from "./credits.vue?vue&type=template&id=3dab0046&scoped=true&"
import script from "./credits.vue?vue&type=script&lang=js&"
export * from "./credits.vue?vue&type=script&lang=js&"
import style0 from "./credits.vue?vue&type=style&index=0&id=3dab0046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab0046",
  null
  
)

export default component.exports